import { animate, AnimationMetadata, style } from '@angular/animations';

export const RouteChangeAnimation: AnimationMetadata[] = [
  style({
    transform: 'translateY(-3%)',
    opacity: 0,
    position: 'static'
  }),
  animate(
    '0.5s ease-in-out',
    style({ transform: 'translateY(0%)', opacity: 1 })
  )
];
